import { createLoadTiming } from './load-timing';
import type { LoadSegment } from './load-timing';

export const ENTRIES_PERF_DEBUG_KEY = 'cognito:entries-perf';

export const ENTRIES_PHASES = [
	'page-chunk-loaded',
	'route-enter',
	'model-loaded',
	'legacy-init-start',
	'global-store-ready',
	'session-ready',
	'admin-components-ready',
	'admin-api-ready',
	'required-scripts-ready',
	'page-script-ready',
	'legacy-scripts-ready',
	'ready-entries',
	'ready-init-entries',
	'ready-master',
	'ready-detail',
	'entries-init',
	'change-view',
	'internal-api-ready',
	'admin-session-ready',
	'form-definition-ready',
	'entry-model-ready',
	'entry-set-ready',
	'index-request-start',
	'index-response',
	'index-processed',
	'grid-bound',
	'entry-batch-start',
	'entry-batch-end',
	'lookup-batch-start',
	'lookup-batch-end',
	'rows-populated'
] as const;

export type EntriesPhase = typeof ENTRIES_PHASES[number];

export const ENTRIES_LOAD_SEGMENTS: LoadSegment<EntriesPhase>[] = [
	{ name: 'document + spa boot', start: 'navigation-start', end: 'load-start' },
	{ name: 'route chunk + guards', start: 'load-start', end: 'route-enter' },
	{ name: 'route guards', start: 'load-start', end: 'route-guards-done' },
	{ name: 'page chunk download + eval', start: 'route-guards-done', end: 'page-chunk-loaded' },
	{ name: 'getModel', start: 'route-enter', end: 'model-loaded' },
	{ name: 'model -> legacy init', start: 'model-loaded', end: 'legacy-init-start' },
	{ name: 'globalStore.isReady', start: 'legacy-init-start', end: 'global-store-ready' },
	{ name: 'getActiveSession', start: 'global-store-ready', end: 'session-ready' },
	{ name: 'admin components', start: 'session-ready', end: 'admin-components-ready' },
	{ name: 'admin api (admin.js + session)', start: 'session-ready', end: 'admin-api-ready' },
	{ name: 'required scripts', start: 'session-ready', end: 'required-scripts-ready' },
	{ name: 'page script', start: 'required-scripts-ready', end: 'page-script-ready' },
	{ name: 'legacy scripts + templates', start: 'required-scripts-ready', end: 'legacy-scripts-ready' },
	{ name: 'initEntriesPage -> changeView', start: 'entries-init', end: 'change-view' },
	{ name: 'getEntrySet (index cache)', start: 'change-view', end: 'entry-set-ready' },
	{ name: 'index request', start: 'index-request-start', end: 'index-response' },
	{ name: 'index processing', start: 'index-response', end: 'index-processed' },
	{ name: 'bind grid', start: 'index-processed', end: 'grid-bound' },
	{ name: 'first entry batch', start: 'entry-batch-start', end: 'entry-batch-end' },
	{ name: 'first lookup batch', start: 'lookup-batch-start', end: 'lookup-batch-end' },
	{ name: 'grid bound -> rows populated', start: 'grid-bound', end: 'rows-populated' },
	{ name: 'pre-grid', start: 'navigation-start', end: 'change-view' },
	{ name: 'time to grid bound', start: 'navigation-start', end: 'grid-bound' },
	{ name: 'time to rows populated', start: 'navigation-start', end: 'rows-populated' }
];

export const entriesLoadTiming = createLoadTiming({
	name: 'entries',
	phases: ENTRIES_PHASES,
	segments: ENTRIES_LOAD_SEGMENTS,
	measures: ['entry-construct', 'entry-initialize'],
	requiredPhase: 'change-view',
	summaryPhases: ['grid-bound', 'rows-populated'],
	debugKey: ENTRIES_PERF_DEBUG_KEY
});
